/********************************************
 * Accordion
 ********************************************/
function fnAccordion(i, oSection) {

    var oSection = $(oSection),
        oImagesSlider = $('.images-slider', oSection),
        oImage = $('.image-src', oSection),
        oAccordions = $('ul.accordions', oSection);

    var $oFlickity = oImagesSlider.flickity({
        accessibility: false,
        autoPlay: false,
        draggable: false,
        prevNextButtons: false,
        imagesLoaded: true,
        percentPosition: false,
        pageDots: false,
        setGallerySize: false,
        selectedAttraction: 0.01,
        fade: true,
        cellSelector: '.image-src'
    });


    /*    var iPrevIndex = null,
            iIndex = 0,
            sClass = '',
            sDirection = '';*/

    oAccordions.find('.accordion .accordion-title').click(function (ev) {
        var oAccordion = $(this).parent('.accordion'),
            iIndex = oAccordion.index();
        $('.accordion').removeClass('is-current');
        oAccordion.addClass('is-current');
        $oFlickity.flickity('select', iIndex);
        /*        iPrevIndex = iIndex;
                console.log(iPrevIndex, iIndex);
                if(iPrevIndex < iIndex){
                    sDirection = 'scroll-left';
                    sClass = 'is-inactive-prev';
                } else{
                    sDirection = 'scroll-right';
                    sClass = 'is-inactive-next';
                }
                oSection.find('.images').removeClass('scroll-left scroll-right').addClass(sDirection);
                $('.image-src').removeClass('is-current is-inactive');
                oSection.find('.image-src').eq(iPrevIndex).addClass('is-inactive');
                oSection.find('.image-src').eq(iIndex).addClass('is-current');*/
/*        setTimeout(function () {
            locoScroll.update();
        }, 500)*/
        ev.preventDefault();
    });

    /**
     * Parallax images
     * NOTE: Does not work when 'wrapAround' is set to true
     */
    // var aCarouselData = $oFlickity.data('flickity'),
    //     $oImages = $oFlickity.find('.image-src'),
    //     docStyle = document.documentElement.style,
    //     transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    // if ($oImages.length > 2) {
    //
    //     aCarouselData.slides.forEach(function (slide, i) {
    //
    //         var oImage = $oImages[i],
    //             x = 0;
    //
    //         if (0 === i) {
    //             x = Math.abs(aCarouselData.x) > aCarouselData.slidesWidth ? (aCarouselData.slidesWidth + aCarouselData.x + aCarouselData.slides[aCarouselData.slides.length - 1].outerWidth + slide.target) : (slide.target + aCarouselData.x);
    //         } else if (i === aCarouselData.slides.length - 1) {
    //             x = Math.abs(aCarouselData.x) + aCarouselData.slides[i].outerWidth < aCarouselData.slidesWidth ? (slide.target - aCarouselData.slidesWidth + aCarouselData.x - aCarouselData.slides[i].outerWidth) : (slide.target + aCarouselData.x);
    //         } else {
    //             x = slide.target + aCarouselData.x;
    //         }
    //
    //         oImage.style[transformProp] = 'translateX(' + x * (-1 / 3) + 'px)';
    //
    //     });
    //
    // }

}


// END OF DOCUMENT
